var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWritereview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#AED9F1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3007_954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.933 13.3331H15.9997C15.6461 13.3331 15.3069 13.4736 15.0569 13.7236C14.8068 13.9737 14.6663 14.3128 14.6663 14.6664V25.3331C14.6663 25.6867 14.8068 26.0259 15.0569 26.2759C15.3069 26.526 15.6461 26.6664 15.9997 26.6664H23.9997C24.3533 26.6664 24.6924 26.526 24.9425 26.2759C25.1925 26.0259 25.333 25.6867 25.333 25.3331V20.3998M13.333 15.9998H15.9997M13.333 18.6664H15.9997M13.333 21.3331H15.9997M13.333 23.9998H15.9997M26.2517 15.7504C26.5172 15.4849 26.6664 15.1247 26.6664 14.7491C26.6664 14.3735 26.5172 14.0133 26.2517 13.7478C25.9861 13.4822 25.6259 13.333 25.2503 13.333C24.8748 13.333 24.5146 13.4822 24.249 13.7478L20.909 17.0891C20.7505 17.2475 20.6345 17.4433 20.5717 17.6584L20.0137 19.5718C19.9969 19.6291 19.9959 19.6899 20.0108 19.7478C20.0256 19.8057 20.0557 19.8586 20.098 19.9008C20.1402 19.9431 20.1931 19.9732 20.2509 19.988C20.3088 20.0028 20.3696 20.0018 20.427 19.9851L22.3403 19.4271C22.5555 19.3643 22.7513 19.2483 22.9097 19.0898L26.2517 15.7504Z",
    stroke: "#0088FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3007_954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWritereview);
export default __webpack_public_path__ + "static/media/writereview.53c2c845d97f2c0f6455320eea8a57ad.svg";
export { ForwardRef as ReactComponent };